import {
  MAutocomplete,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import {
  useInstallation,
  useTypeSample,
} from "@services/servicesGenericsTables";
import useFilteredSamplingPoints from "@app/hooks/useFilteredSamplingPoints";
import React from "react";
import { useFormContext, useWatch } from "react-hook-form";

const DosimetrosForm = () => {
  const { getValues, control } = useFormContext();
  const { installationList } = useInstallation();
  const { sampleTypeList } = useTypeSample();

  const instalacion = useWatch({ control, name: "instalacion" });
  const filteredSamplingPoints = useFilteredSamplingPoints(
    instalacion,
    "puntomuestreo"
  );

  return (
    <>
      <ResponsiveFormContainer columns={4}>
        <MAutocomplete
          key={JSON.stringify(getValues("instalacion"))}
          name="instalacion"
          options={installationList}
          label="Instalación"
          getOptionLabel={(option) =>
            `${option.codigo} - ${option.descripcion}`
          }
          validation={{ required: "La instalación es requerida" }}
        />
        <MAutocomplete
          key={JSON.stringify(filteredSamplingPoints)}
          name="puntomuestreo"
          options={filteredSamplingPoints}
          label="Punto de Muestreo"
          getOptionLabel={(option) =>
            `${option.codigo} - ${option.descripcion}`
          }
          validation={{ required: "El punto de muestreo es requerido" }}
        />
        <MAutocomplete
          key={JSON.stringify(getValues("tipomuestra"))}
          name="tipomuestra"
          options={sampleTypeList}
          label="Tipo de Muestra"
          getOptionLabel={(option) =>
            `${option.codigo} - ${option.descripcion}`
          }
          validation={{ required: "El tipo de muestra es requerido" }}
        />
        <MTextField
          key={"grupo"}
          name={"grupo"}
          label={"Grupo"}
          type="text"
          fullWidth
          validation={{ required: `El campo grupo es requerido` }}
        />
        <MTextField
          key={"numero"}
          name={"numero"}
          label={"Numero"}
          type="text"
          fullWidth
          validation={{ required: `El campo numero es requerido` }}
        />
        <MTextField
          key={"sigmas"}
          name={"sigmas"}
          label={"Sigmas"}
          type="text"
          fullWidth
          validation={{ required: `El campo sigmas es requerido` }}
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default DosimetrosForm;
